/* على الموقع لا يُحمّل desk.js — نعرّف frappe.app.logout مثل الـ desk حتى يعمل onclick="return frappe.app.logout();" */
(function () {
	function patchWebsiteLogout() {
		if (typeof window.frappe === "undefined" || typeof frappe.call !== "function") return;
		frappe.app = frappe.app || {};
		if (typeof frappe.app.logout === "function") return;
		frappe.app.logout = function () {
			return frappe.call({
				method: "logout",
				callback: function (r) {
					if (r && r.exc) return;
					window.location.href =
						"/login?redirect-to=" +
						encodeURIComponent(window.location.pathname + window.location.search);
				},
			});
		};
	}
	if (typeof window.frappe !== "undefined" && typeof frappe.ready === "function") {
		frappe.ready(patchWebsiteLogout);
	} else {
		document.addEventListener("DOMContentLoaded", patchWebsiteLogout);
	}
})();

(function () {
	const nav = document.getElementById("mewNav");
	if (!nav) return;

	const toggleBtn = document.getElementById("mewNavToggle");
	const closeBtn = document.getElementById("mewNavClose");
	const drawer = document.getElementById("mewNavDrawer");
	const backdrop = document.getElementById("mewNavBackdrop");
	const navLinks = nav.querySelectorAll("[data-mew-nav-link]");

	function setOpen(open) {
		nav.setAttribute("data-mew-open", open ? "true" : "false");
		if (toggleBtn) toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
		if (drawer) drawer.hidden = !open;
		if (backdrop) backdrop.hidden = !open;
		document.documentElement.style.overflow = open ? "hidden" : "";
		document.body.style.overflow = open ? "hidden" : "";
	}

	if (toggleBtn) {
		toggleBtn.addEventListener("click", function () {
			setOpen(nav.getAttribute("data-mew-open") !== "true");
		});
	}

	if (closeBtn) closeBtn.addEventListener("click", () => setOpen(false));
	if (backdrop) backdrop.addEventListener("click", () => setOpen(false));
	navLinks.forEach((a) => a.addEventListener("click", () => setOpen(false)));

	/* إغلاق الدرج بعد اختيار عنصر من قائمة الحساب (الموبايل) */
	nav.querySelectorAll(".mew-nav__dropdown-menu--drawer .dropdown-item").forEach(function (el) {
		el.addEventListener("click", function () {
			setOpen(false);
		});
	});

	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape") setOpen(false);
	});

	const path = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
	nav.querySelectorAll("a[data-mew-nav-link]").forEach(function (a) {
		const href = (a.getAttribute("href") || "/").replace(/[?#].*$/, "").replace(/\/+$/, "") || "/";
		if (href === path) a.setAttribute("aria-current", "page");
		else a.removeAttribute("aria-current");
	});

	function handleScroll() {
		if (window.scrollY > 8) nav.classList.add("mew-nav--scrolled");
		else nav.classList.remove("mew-nav--scrolled");
	}
	handleScroll();
	window.addEventListener("scroll", handleScroll, { passive: true });

	setOpen(false);

	/* بعد تنقل الموقع: إعادة رسم الأفاتار (صورة / أحرف) في الشريط */
	if (typeof window.jQuery !== "undefined" && window.frappe && typeof frappe.render_user === "function") {
		jQuery(document).on("page-change", function () {
			frappe.render_user();
		});
	}
})();

(function () {
	const yearEl = document.getElementById("mewFooterYear");
	if (yearEl) yearEl.textContent = String(new Date().getFullYear());
})();
